/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-04-13 17:45:19
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-11-11 11:15:35
 */
import { getSession } from '@/utils/storage';

import { getToken } from '../../utils/system';
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  currentTab: [],
  priList: JSON.parse(getSession('rbacPriList')) || [],
  menuOptions: [],
  privilegeBtns: [],
  account: '',
  userInfo: null,
  menuCollapsed: true,
};

const mutations = {
  SET_TOKEN: (state: any, token: any) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state: any, introduction: any) => {
    state.introduction = introduction;
  },
  SET_NAME: (state: any, name: any) => {
    state.name = name;
  },
  SET_AVATAR: (state: any, avatar: any) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state: any, roles: any) => {
    state.roles = roles;
  },
  SET_TAB: (state: any, currentTab: any) => {
    state.currentTab = currentTab;
  },
  SET_PRILIST: (state: any, priList: any) => {
    state.priList = priList;
  },
  SET_PRIVILEGEBTNS: (state: any, privilegeBtns: any) => {
    state.privilegeBtns = privilegeBtns;
  },
  SET_MENUOPTIONS: (state: any, menuOptions: any) => {
    state.menuOptions = menuOptions;
  },
  SET_ACCOUNT: (state: any, account: any) => {
    state.account = account;
  },
  SET_ROLENAMES: (state: any, roleNames: any) => {
    state.roleNames = roleNames;
  },
  SET_USERINFO: (state: any, userInfo: any) => {
    state.userInfo = userInfo;
  },
  SET_COLLAPSED: (state: any, flag: any) => {
    state.menuCollapsed = flag;
  },
};

const actions = {
  loginByToken({ commit }: any, token: any) {
    commit('SET_TOKEN', token);
  },
  setTab({ commit }: any, data: any) {
    commit('SET_TAB', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
